module.exports = __webpack_public_path__ + "img/day-pass.5c91763a.svg";